import React from "react";
import { Calendar, Clock } from "lucide-react";
import { fmtDate } from "@/lib/format";

const fmtDay = (s) => new Date(`${s}T12:00:00`).toLocaleDateString("it-IT", { weekday: "short", day: "numeric", month: "short", year: "numeric" });

export function LeavePeriod({ req, compact = false }) {
  if (!req?.date_from) return null;
  const multi = req.date_to && req.date_to !== req.date_from;
  const time = req.time_from && req.time_to ? `${req.time_from} – ${req.time_to}` : req.half_day ? "Mezza giornata" : "Giornata intera";
  if (compact) {
    return (
      <span data-testid={`req-period-${req.id}`} className="inline-flex items-center gap-1 text-[#1C352D]">
        <Calendar size={11} /> {fmtDate(req.date_from)}{multi && <> → {fmtDate(req.date_to)}</>}
        <Clock size={11} className="ml-1.5" /> {time}
      </span>
    );
  }
  return (
    <div className="rounded-lg border border-[#1C352D]/20 bg-[#1C352D]/[0.04] p-3 space-y-1.5" data-testid="req-period-box">
      <div className="text-[10px] uppercase tracking-widest text-stone-500">Periodo richiesto</div>
      <div className="flex items-center gap-2 text-sm font-medium text-[#1C352D]" data-testid="req-period-dates">
        <Calendar size={14} />
        {multi ? <>dal {fmtDay(req.date_from)} al {fmtDay(req.date_to)}</> : fmtDay(req.date_from)}
      </div>
      <div className="flex items-center gap-2 text-sm font-medium text-[#1C352D]" data-testid="req-period-time">
        <Clock size={14} />
        {req.time_from && req.time_to ? <>dalle {req.time_from} alle {req.time_to}{multi && <span className="text-xs font-normal text-stone-500 ml-1">(ogni giorno)</span>}</> : time}
      </div>
    </div>
  );
}
